var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3861 1.9188L21.0215 9.34992C21.173 9.64717 21.476 9.94442 21.9304 9.94442L30.2617 11.1334C31.1706 11.282 31.625 12.471 30.8676 13.0655L24.8085 18.8618C24.5055 19.159 24.3541 19.4563 24.5055 19.9021L25.8689 27.9277C26.0203 28.8195 24.96 29.5626 24.2026 29.1167L16.7802 25.2525C16.4772 25.1039 16.0228 25.1039 15.7198 25.2525L8.29741 29.1167C7.38854 29.5626 6.47967 28.8195 6.63114 27.9277L7.99446 19.9021C7.99446 19.6049 7.99446 19.159 7.69151 18.8618L1.63239 13.0655C0.875003 12.471 1.32943 11.282 2.23829 11.1334L10.5696 9.94442C11.024 9.94442 11.327 9.64717 11.4785 9.34992L15.1139 1.9188C15.7198 1.02707 16.9317 1.02707 17.3861 1.9188Z",
    stroke: "#02283D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar2);
export default __webpack_public_path__ + "static/media/icon_star2.32d92ccfc44cab96a26008a8867dbc42.svg";
export { ForwardRef as ReactComponent };